define([
    'common/ui/view/svg/icon',
    'common/ui/view/svg/index',
    'common/ui/view/svg/mark/index',
    'common/ui/view/svg/util'
], function(
    IconView,
    SVGView,
    Mark,
    SVGUtil
    ) {
    return SVGView.extend({
        className: 'transient-selector',

        initialize: function(params) {
            this.constructor.__super__.initialize.call(this, params);
            _.bindAll(this, 'remove', 'onClick');
            this._sizeFactor = params.sizeFactor ? params.sizeFactor : 1.0;
            this._ringR = 48;
            this._pos = params.pos;
            this._scale = params.scale;
            this._scaleFactor = 1;
            this._pos.scale = 1 / this._scale * this._scaleFactor;
        },

        render: function() {
            this.$el.attr('transform', SVGUtil.transform(this._pos));
            this.$el.on('click', this.onClick);

            this._render();
            setTimeout(this.remove, 2000);

            return this;
        },

        _render: function() {
            var maxR = this._ringR * this._sizeFactor;
            var strokeWidth = 4 * this._sizeFactor;

            this.$el
                .style('opacity', 0);
            this.$el.transition()
                .delay(350)
                .duration(100)
                .style('opacity', 1);

            for(var i = 0; i < 4; i++) {
                var selector = this.$el.append('g')
                    .classed('transient-selector-item', true);
                selector.append('path')
                    .attr('d', d3.svg.arc()
                        .innerRadius(maxR - strokeWidth / 2)
                        .outerRadius(maxR + strokeWidth / 2)
                        .startAngle((i / 2 + 1 / 4 - 1 / 12) * Math.PI)
                        .endAngle((i / 2 + 1 / 4 + 1 / 12) * Math.PI)
                    );

                var angle = i * 90 + 45;
                var r = maxR * 1.2;
                var g = selector.append('g')
                    .attr('transform', SVGUtil.transform({
                        x: r * Math.sin(Math.PI * angle / 180),
                        y: - r * Math.cos(Math.PI * angle / 180),
                        rotate: angle
                    }));

                g.append((new Mark({
                        type: 'triangle',
                        size: 0.3
                    })).render().el)
                    .classed('transient-selector-arrow', true);

                // 選択しやすいように透明な path をかぶせておく
                g.append((new Mark({
                        type: 'triangle',
                        size: 1
                    })).render().el)
                    .style('visibility', 'hidden');
            }
        },

        onClick: function() {
            d3.event.stopPropagation();
            d3.event.preventDefault();
            this.trigger('click', this);
        },

        remove: function() {
            this.$el.transition()
                .duration(400)
                .style('opacity', 0)
                .remove();
        }
    });
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/transient-selector.js